import React from 'react'
import { PointrThemedNavbar } from '../../smart-components/pointr-themed-navbar'
import { MKT_PAGES, VERSION } from '../../config/constants/env'
import cx from 'classnames'
import usePointrThemedContainerStyles from './Styles'
import { IPointrThemedContainerProps } from './Interface'

const PointrThemedContainer: React.FC<IPointrThemedContainerProps> = ({
  children,
  withGradientNavbar,
  withBeansBackground
}) => {
  const classes = usePointrThemedContainerStyles({})

  const clickEventLogger = () => {}

  return (
    <div className={withBeansBackground ? classes.root : cx(classes.root, classes.neBeanBackground)}>
      <PointrThemedNavbar useBackground={withGradientNavbar} />
      {children}
      <div className={classes.footerContent}>
        <div className={classes.footerInner}>
          <div className={classes.footer}>
            <div className={classes.footerList}>
              <div className={classes.footerListItem}>
                <a
                  className={classes.footerLink}
                  href={`${MKT_PAGES.BASE_URL}/copyright`}
                  id="pointr-copyright-link"
                  onClick={clickEventLogger}
                >
                  Copyright © 2020 Pointr
                </a>
              </div>
              <div className={classes.footerListItem}>
                <a
                  className={classes.footerLink}
                  href="mailto: support@pointr.co"
                  id="pointr-support-link"
                  onClick={clickEventLogger}
                >
                  support@pointr.co
                </a>
              </div>
              <div className={classes.footerListItem}>
                <a
                  className={cx(classes.footerLink, 'iubenda-nostyle', 'no-brand', 'iubenda-embed')}
                  title="Terms"
                  href={`${MKT_PAGES.BASE_URL}/terms`}
                  id="pointr-terms-ans-conditions-link"
                  rel="noreferrer noopener"
                  onClick={clickEventLogger}
                >
                  Terms and Conditions
                </a>
              </div>
              <div className={classes.footerListItem}>
                <a
                  className={cx(classes.footerLink, 'iubenda-nostyle', 'no-brand', 'iubenda-embed')}
                  title="Privacy"
                  href={`${MKT_PAGES.BASE_URL}/privacy`}
                  id="pointr-privacy-link"
                  rel="noreferrer noopener"
                  onClick={clickEventLogger}
                >
                  Privacy Policy
                </a>
              </div>
              <div className={classes.footerListItem}>
                <a id="pointr-app-version-link" href="#version-link" className={classes.footerLink}>
                  v{VERSION}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

PointrThemedContainer.defaultProps = {
  withBeansBackground: true
}

export default PointrThemedContainer
